// src/types/package.types.ts

export type PackageStatus =
  | 'CREATED'
  | 'IN_TRANSIT'
  | 'OUT_FOR_DELIVERY'
  | 'DELIVERED'
  | 'DELIVERY_FAILED'
  | 'RETURNED';

export interface AddressDto {
  street: string;
  city: string;
  state?: string;
  country: string;
  postalCode: string;
  fullAddress?: string;
}

export interface RecipientDto {
  name: string;
  email: string;
  phone: string;
  address: AddressDto;
}

export interface DimensionsDto {
  height: number;
  width: number;
  depth: number;
  volume: number;
}

export interface LocationDto {
  city: string;
  country: string;
  description: string;
  timestamp: string;
  latitude?: number;
  longitude?: number;
}

export interface PackageResponse {
  id: string;
  recipient: RecipientDto;
  dimensions: DimensionsDto;
  weight: number;
  status: PackageStatus;
  locations: LocationDto[];
  currentLocation: string;
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePackageCommand {
  recipientName: string;
  recipientEmail: string;
  recipientPhone: string;
  street: string;
  city: string;
  state?: string;
  country: string;
  postalCode: string;
  height: number;
  width: number;
  depth: number;
  weight: number;
  notes?: string;
}

export interface AddLocationCommand {
  packageId?: string;
  city: string;
  country: string;
  description: string;
  latitude?: number;
  longitude?: number;
}

export interface PackageSearchCriteria {
  recipientName?: string;
  recipientEmail?: string;
  status?: PackageStatus;
  dateFrom?: string;
  dateTo?: string;
  includeDeleted?: boolean;
}

export interface PagedResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
  timestamp?: string;
}

export const PACKAGE_STATUS_LABELS: Record<PackageStatus, string> = {
  CREATED:          'Creado',
  IN_TRANSIT:       'En tránsito',
  OUT_FOR_DELIVERY: 'En reparto',
  DELIVERED:        'Entregado',
  DELIVERY_FAILED:  'Entrega fallida',
  RETURNED:         'Devuelto',
};

export const PACKAGE_STATUS_COLORS: Record<PackageStatus, string> = {
  CREATED:          '#6b7280',
  IN_TRANSIT:       '#8b5cf6',
  OUT_FOR_DELIVERY: '#06b6d4',
  DELIVERED:        '#10b981',
  DELIVERY_FAILED:  '#ef4444',
  RETURNED:         '#f97316',
};
